export default __webpack_public_path__ + "static/media/Swiss721BTMedium.4c579e84.woff";